import React, { useCallback } from 'react';

import type { BannerProps } from './types';
import { getBannerBackgroundSrc } from './utils';

import styles from './styles.module.scss';

export const Banner = (props: BannerProps): React.ReactElement => {
  const {
    title,
    description,
    buttonLabel,
    backgroundImageSrc,
    backgroundImageAlt = '',
    scrollTargetRef,
    onExploreClick,
  } = props;

  const handleExploreClick = useCallback(() => {
    onExploreClick?.();
    scrollTargetRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, [scrollTargetRef, onExploreClick]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleExploreClick();
      }
    },
    [handleExploreClick],
  );

  const bgSrc = getBannerBackgroundSrc(backgroundImageSrc);

  return (
    <section className={styles.banner} aria-label={title}>
      <div className={styles.background}>
        <img
          src={bgSrc}
          alt={backgroundImageAlt}
          className={styles.backgroundImage}
          loading="eager"
        />
      </div>
      <div className={styles.content}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{description}</p>
        <button
          type="button"
          className={styles.exploreButton}
          onClick={handleExploreClick}
          onKeyDown={handleKeyDown}
          aria-label={buttonLabel}
        >
          {buttonLabel}
        </button>
      </div>
    </section>
  );
};
